import React, { useCallback, useState } from 'react';
import SettingsCard from '../../organisms/SettingsCard';
import Stepper from '../../organisms/Stepper';
import TableCardGrid from '../../organisms/TableCardGrid';
import { useSettingsWizard } from '../../../context/SettingsWizardContext';
import { SETTINGS_STEPS } from '../../../data/settingsSteps';
import { useDispatch, useSelector } from 'react-redux';
import { updateWorkflowSteps } from '../../../redux/Workflow/actions';




export default function WorkflowStep({
  onNext: _onNext,
  stepMeta,
  stepperProps,
  selectedTableCard,
  pageProps,

}) {
  const { state, updateWorkflow: updateWizardWorkflow } = useSettingsWizard();
  const { workflow } = state;
  const [updatePayload, setUpdatePayload] = useState(null);
  const handleUpdatePayload = useCallback((payload) => {
    setUpdatePayload(payload);
  }, []);
  const dispatch = useDispatch();


  let { id } = useSelector((state) => state.appDetails || {});
 
  // const { id } = useParams();



  

  // const SelectedTableCard=null;
  const resolvedSelectedTableCard = selectedTableCard ?? workflow.selectedTableCard ?? null;


  const onSubmit = async () => {
    if (!updatePayload) {
      console.warn('WorkflowStep: workflow steps are not ready to save.');
      return;
    }

    console.log('WorkflowStep update payload:', updatePayload);
    dispatch(
      updateWorkflowSteps({
        id: updatePayload.id,
        tables: updatePayload,
        onSuccess: (data) => {
          console.log('updateWorkflowSteps onSuccess:', data);
          stepperProps.onNext?.();
        },
        onFail: (error) => console.log('updateWorkflowSteps onFail:', error),
      }),
    );

    // if (updateWorkflowSteps.fulfilled.match(resultAction)) {
    //   stepperProps.onNext?.();
    // }
  };

  return (
    <>
      {/* Main wizard stepper */}
      <Stepper
        {...stepperProps}
        steps={SETTINGS_STEPS}
        onNext={onSubmit}
        showNextButton
      />

      <SettingsCard
        title={stepMeta.title}
        description={stepMeta.description}
        showNext={false}
      >
     

          {/* Workflow Table Grid */}
          <div className="ca-workflow__main">
            <TableCardGrid
              id={id}
              selectedTableId={resolvedSelectedTableCard?.id}
              onSelect={(table) => updateWizardWorkflow({ selectedTableCard: table })}
              // onNext={stepperProps.onNext}
              setUpdatePayload={handleUpdatePayload}
              pageProps={pageProps}
              // onChange={(steps) =>
              //   updateWorkflow({
              //     steps,
              //     selectedTableCard: resolvedSelectedTableCard
              //       ? steps.find((step) => step.id === resolvedSelectedTableCard.id) ?? null
              //       : null,
              //   })
              // }
            />
          </div>
        {/* </div> */}
      </SettingsCard>
    </>
  );
}